import { apiToken, pricingTiersUrl } from "../config";

// add pricing tier start
export const addPricingTier = async (formData) => {
  try {
    const response = await fetch(pricingTiersUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiToken}`,
      },
      body: JSON.stringify(formData),
    });

    const res = await response.json();
    if (!response.ok) throw new Error(res?.message || `HTTP error! status: ${response.status}`);
    return res;
  } catch (e) {
    console.error("Error adding pricing tier:", e);
    throw e;
  }
};
// add pricing tier end

// get all active pricing tiers start
export const getAllActivePricingTiers = async () => {
  try {
    const response = await fetch(`${pricingTiersUrl}/all`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiToken}`,
      },
    });

    const res = await response.json();
    if (!response.ok) throw new Error(res?.message || `HTTP error! status: ${response.status}`);
    return res.data;
  } catch (e) {
    console.error("Error fetching active pricing tiers:", e);
    throw e;
  }
};
// get all active pricing tiers end

// get pricing tier by id start
export const getPricingTierById = async (id) => {
  try {
    const response = await fetch(`${pricingTiersUrl}/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiToken}`,
      },
    });

    const res = await response.json();
    if (!response.ok) throw new Error(res?.message || `HTTP error! status: ${response.status}`);
    return res.data;
  } catch (e) {
    console.error("Error fetching pricing tier by ID:", e);
    throw e;
  }
};
// get pricing tier by id end

// update pricing tier by id start
export const updatePricingTierById = async (id, formData) => {
  try {
    const response = await fetch(`${pricingTiersUrl}/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiToken}`,
      },
      body: JSON.stringify(formData),
    });

    const res = await response.json();
    if (!response.ok) throw new Error(res?.message || `HTTP error! status: ${response.status}`);
    return res;
  } catch (e) {
    console.error("Error updating pricing tier:", e);
    throw e;
  }
};
// update pricing tier by id end

// delete pricing tier by id start
export const deletePricingTierById = async (id) => {
  try {
    const response = await fetch(`${pricingTiersUrl}/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiToken}`,
      },
    });

    const res = await response.json();
    if (!response.ok) throw new Error(res?.message || `HTTP error! status: ${response.status}`);
    return res;
  } catch (e) {
    console.error("Error deleting pricing tier:", e);
    throw e;
  }
};
// delete pricing tier by id end
